<template>
<div :class="vertical ? 'tabs__vert--container' : 'tabs__horz--container'" :id="id">
    <div :class="vertical ? 'tabs__vert--buttons' : 'tabs__horz--buttons'">
        <div v-for="(tab, i) in tabs" :key="i" @click="tabChange" 
        :class="[tab.$props.active ? 'active' : null, tab.$props.disabled ? 'disabled' : null]" 
        class="tab__button js-tab__button">
            <h6>{{tab.$props.name}}</h6>
        </div>
    </div>
    <div :class="vertical ? 'tabs__vert--content' : 'tabs__horz--content'">
        <slot></slot>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            tabs: []
        }
    },
    props: {
        id: { type: String, default: null },
        vertical: { type: Boolean, default: false },
    },
    created() {
        this.tabs = this.$children;
    },
    methods: {
        indexInParent(node) {
            var children = node.parentNode.childNodes;
            var num = 0;
            for (var i = 0; i < children.length; i++) {
                if (children[i] == node)
                    return num;
                if (children[i].nodeType == 1)
                    num++;
            }
            return -1;
        },
        tabChange(e) {
            const clicked_tab = e.target.closest('.tab__button')
            const tab_container = clicked_tab.parentElement.parentElement.id

            let btns = document.querySelectorAll('#' + tab_container + ' .tab__button')
            btns.forEach((btn) => {
                btn.classList.remove('active')
            })

            let content = document.querySelectorAll('#' + tab_container + ' .tab__content')
            content.forEach((btn) => {
                btn.classList.remove('active')
            })

            let newtab = this.indexInParent(clicked_tab)
            let newBody = document.querySelectorAll('#' + tab_container + ' .tab__content')
            clicked_tab.classList.add('active')
            newBody[newtab].classList.add('active')
        }
    },
}
</script>